/**
 * Labstep
 *
 * @module components/Layout/Menu/Content/UserGroups
 * @desc Left side bar user group list
 */

import { LayoutMenuLeftContentUserGroupsCollapsible as Collapsible } from 'labstep-web/components/Layout/Menu/Left/Content/UserGroups/Collapsible';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import type React from 'react';
import type { LayoutMenuLeftContentUserGroupsProps } from './types';

export const LayoutMenuLeftContentUserGroups: React.FC<
  LayoutMenuLeftContentUserGroupsProps
> = ({ activeGroup }) => {
  const params: Record<string, unknown> = {
    count: 5,
    sort: '-is_home',
    is_group_deleted: 0,
  };
  if (activeGroup) {
    params.not_group_id = activeGroup.id;
  }
  return (
    <>
      {activeGroup && (
        <Collapsible group={activeGroup} initialExpandedState />
      )}
      <ReadOnMountHOC
        type="cursor"
        entityName="user_group"
        params={params}
        pagination={{
          loader: false,
          showMore: false,
          infinite: false,
        }}
        children={({ entities: userGroups }) => (
          <>
            {userGroups
              .filter((userGroup) => !userGroup.deleted_at)
              .map((userGroup) => (
                <Collapsible
                  key={userGroup.id}
                  group={userGroup.group}
                />
              ))}
          </>
        )}
      />
    </>
  );
};

export default withActiveGroup(LayoutMenuLeftContentUserGroups);
